import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

export const baseRoutes: Routes = [
  {
    path: '',
    data: { title: 'Charges' },
    children: [
      {
        path: 'customer-origin-charge',
        loadChildren: () => import('./customer-origin-charge/customer-origin-charge.module')
          .then(m => m.CustomerOriginChargeModule)
      },
      {
        path: 'standard-origin-charge',
        loadChildren: () => import('./standard-origin-charge/standard-origin-charge.module')
          .then(m => m.StandardOriginChargeModule)
      },
      {
        path: 'standard-destination-charge',
        loadChildren: () => import('./standard-destination-charge/standard-destination-charge.module')
          .then(m => m.StandardDestinationChargeModule)
      },
      {
        path: 'customer-destination-charge',
        loadChildren: () => import('./customer-destination-charge/customer-destination-charge.module')
          .then(m => m.CustomerDestinationChargeModule)
      },
      {
        path: 'country-wise-other-charges',
        loadChildren: () => import('./country-wise-other-charges/country-wise-other-charges.module')
          .then(m => m.CountryWiseOtherChargesModule)
      }
    ]
  }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(baseRoutes)
  ]
})
export class ChargesModule { }
